

import React, { useEffect } from 'react';
import { usePlacesWidget } from "react-google-autocomplete";
import CommonInput from '../CommonInput';

const MapInput = ({ label, handleInputChange,value,placeholder="Location" ,setSelectLoctionDetails=()=>{},error=""}) => {
  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyAkWxbuO-maU16USeyELd3UP0hPLITP3Ec",
    onPlaceSelected: (place) => {
      handleInputChange(place); 
      setSelectLoctionDetails(place);
    },
    options: {
      types: [],
      componentRestrictions: { country: 'in' },
fields: ["address_components", "geometry", "formatted_address", "name", "place_id"],
    },
  });

  return (
    <div className="anvCustom_floatInput form-floating">
      <input
        id={label}
        className="form-control"
        placeholder={placeholder}
        autoComplete='off'
        ref={ref} 
        value={value} // Set the value programmatically
        onChange={(e) => handleInputChange({ formatted_address: e.target.value })}
      />
      <label htmlFor={label}>
        <span>{label}</span>
      </label>
       {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

export default MapInput;
